/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Icon, Pressable } from '@components/atoms'
import { grey } from '@mui/material/colors'

import { useAppSelector, useAppDispatch, configActions } from '@redux/index'

export const DrawerToggleButton = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)

	// state
	const [isHovering, setIsHovering] = React.useState<boolean>(false)

	const onToggleClick = React.useCallback(() => {
		reduxDispatch(configActions.IS_OPEN_DRAWER(!isOpenDrawer))
	}, [isOpenDrawer])

	const onMouseOver = React.useCallback(() => {
		setIsHovering(true)
	}, [])

	const onMouseLeave = React.useCallback(() => {
		setIsHovering(false)
	}, [])

	return (
		<Pressable
			className="toggleButton"
			css={style}
			onMouseOver={onMouseOver}
			onMouseLeave={onMouseLeave}
			onClick={onToggleClick}
		>
			<Icon
				style={{
					position: 'absolute',
					fontSize: isHovering ? '20px' : '14px',
					color: isHovering ? grey[800] : grey[500],
				}}
				name={isOpenDrawer ? 'chevron-double-left' : 'chevron-double-right'}
			/>
		</Pressable>
	)
}

const style = css({
	position: 'absolute',
	zIndex: 10000,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '1.3rem',
	height: '1.3rem',
	top: '0.7rem',
	right: '-.7rem',
	borderRadius: '50%',
	background: grey[100],
	border: `1px solid ${grey[300]}`,

	'&:hover': {
		width: '1.8rem',
		height: '1.8rem',
		top: '0.5rem',
		right: '-1rem',
	},
})
